// app/redux/actions/leaveRequestsActions.js

// ===================== TYPES =====================
export const SET_LEAVE_REQUEST_LOADING = "SET_LEAVE_REQUEST_LOADING";
export const CLEAR_LEAVE_REQUEST_MESSAGE = "CLEAR_LEAVE_REQUEST_MESSAGE";

// Mine
export const GET_MY_LEAVE_REQUESTS_REQUEST = "GET_MY_LEAVE_REQUESTS_REQUEST";
export const GET_MY_LEAVE_REQUESTS_SUCCESS = "GET_MY_LEAVE_REQUESTS_SUCCESS";
export const GET_MY_LEAVE_REQUESTS_FAIL = "GET_MY_LEAVE_REQUESTS_FAIL";

// Create
export const CREATE_LEAVE_REQUEST_REQUEST = "CREATE_LEAVE_REQUEST_REQUEST";
export const CREATE_LEAVE_REQUEST_SUCCESS = "CREATE_LEAVE_REQUEST_SUCCESS";
export const CREATE_LEAVE_REQUEST_FAIL = "CREATE_LEAVE_REQUEST_FAIL";

// Manager inbox
export const GET_MANAGER_INBOX_REQUEST = "GET_MANAGER_INBOX_REQUEST";
export const GET_MANAGER_INBOX_SUCCESS = "GET_MANAGER_INBOX_SUCCESS";
export const GET_MANAGER_INBOX_FAIL = "GET_MANAGER_INBOX_FAIL";

// Manager history
export const GET_MANAGER_HISTORY_REQUEST = "GET_MANAGER_HISTORY_REQUEST";
export const GET_MANAGER_HISTORY_SUCCESS = "GET_MANAGER_HISTORY_SUCCESS";
export const GET_MANAGER_HISTORY_FAIL = "GET_MANAGER_HISTORY_FAIL";

// Manager team leaves
export const GET_MANAGER_TEAM_LEAVES_REQUEST = "GET_MANAGER_TEAM_LEAVES_REQUEST";
export const GET_MANAGER_TEAM_LEAVES_SUCCESS = "GET_MANAGER_TEAM_LEAVES_SUCCESS";
export const GET_MANAGER_TEAM_LEAVES_FAIL = "GET_MANAGER_TEAM_LEAVES_FAIL";

// Manager decision
export const MANAGER_DECISION_REQUEST = "MANAGER_DECISION_REQUEST";
export const MANAGER_DECISION_SUCCESS = "MANAGER_DECISION_SUCCESS";
export const MANAGER_DECISION_FAIL = "MANAGER_DECISION_FAIL";

// Admin inbox
export const GET_ADMIN_INBOX_REQUEST = "GET_ADMIN_INBOX_REQUEST";
export const GET_ADMIN_INBOX_SUCCESS = "GET_ADMIN_INBOX_SUCCESS";
export const GET_ADMIN_INBOX_FAIL = "GET_ADMIN_INBOX_FAIL";

// Admin decision
export const ADMIN_DECISION_REQUEST = "ADMIN_DECISION_REQUEST";
export const ADMIN_DECISION_SUCCESS = "ADMIN_DECISION_SUCCESS";
export const ADMIN_DECISION_FAIL = "ADMIN_DECISION_FAIL";

// Postpone
export const POSTPONE_LEAVE_REQUEST_REQUEST = "POSTPONE_LEAVE_REQUEST_REQUEST";
export const POSTPONE_LEAVE_REQUEST_SUCCESS = "POSTPONE_LEAVE_REQUEST_SUCCESS";
export const POSTPONE_LEAVE_REQUEST_FAIL = "POSTPONE_LEAVE_REQUEST_FAIL";

// ===================== HELPERS =====================
export const normalizeError = (err, fallback = "Erreur") => {
    if (!err) return fallback;
    if (typeof err === "string") return err;
    if (err?.message) return String(err.message);
    if (err?.error) return String(err.error);
    try {
        return JSON.stringify(err);
    } catch {
        return fallback;
    }
};

// ===================== COMMON =====================
export const setLeaveRequestLoading = (value) => ({
    type: SET_LEAVE_REQUEST_LOADING,
    payload: !!value,
});

export const clearLeaveRequestMessage = () => ({
    type: CLEAR_LEAVE_REQUEST_MESSAGE,
});

// ===================== MINE =====================
export const getMyLeaveRequestsRequest = () => ({
    type: GET_MY_LEAVE_REQUESTS_REQUEST,
});
export const getMyLeaveRequestsSuccess = (data) => ({
    type: GET_MY_LEAVE_REQUESTS_SUCCESS,
    payload: data,
});
export const getMyLeaveRequestsFail = (error) => ({
    type: GET_MY_LEAVE_REQUESTS_FAIL,
    payload: error,
});

// ===================== CREATE =====================
export const createLeaveRequestRequest = (payload) => ({
    type: CREATE_LEAVE_REQUEST_REQUEST,
    payload,
});
export const createLeaveRequestSuccess = (data) => ({
    type: CREATE_LEAVE_REQUEST_SUCCESS,
    payload: data,
});
export const createLeaveRequestFail = (error) => ({
    type: CREATE_LEAVE_REQUEST_FAIL,
    payload: error,
});

// ===================== MANAGER INBOX =====================
export const getManagerInboxRequest = () => ({
    type: GET_MANAGER_INBOX_REQUEST,
});
export const getManagerInboxSuccess = (data) => ({
    type: GET_MANAGER_INBOX_SUCCESS,
    payload: data,
});
export const getManagerInboxFail = (error) => ({
    type: GET_MANAGER_INBOX_FAIL,
    payload: error,
});

// ===================== MANAGER HISTORY =====================
export const getManagerHistoryRequest = () => ({
    type: GET_MANAGER_HISTORY_REQUEST,
});
export const getManagerHistorySuccess = (data) => ({
    type: GET_MANAGER_HISTORY_SUCCESS,
    payload: data,
});
export const getManagerHistoryFail = (error) => ({
    type: GET_MANAGER_HISTORY_FAIL,
    payload: error,
});

// ===================== MANAGER TEAM LEAVES =====================
export const getManagerTeamLeavesRequest = () => ({
    type: GET_MANAGER_TEAM_LEAVES_REQUEST,
});

export const getManagerTeamLeavesSuccess = (payload) => ({
    type: GET_MANAGER_TEAM_LEAVES_SUCCESS,
    payload,
});

export const getManagerTeamLeavesFail = (payload) => ({
    type: GET_MANAGER_TEAM_LEAVES_FAIL,
    payload,
});

// ===================== MANAGER DECISION =====================
// payload attendu: { id, approved, comment }
export const managerDecisionRequest = (payload) => ({
    type: MANAGER_DECISION_REQUEST,
    payload,
});
export const managerDecisionSuccess = (data) => ({
    type: MANAGER_DECISION_SUCCESS,
    payload: data,
});
export const managerDecisionFail = (error) => ({
    type: MANAGER_DECISION_FAIL,
    payload: error,
});

// ===================== ADMIN INBOX =====================
export const getAdminInboxRequest = () => ({
    type: GET_ADMIN_INBOX_REQUEST,
});
export const getAdminInboxSuccess = (data) => ({
    type: GET_ADMIN_INBOX_SUCCESS,
    payload: data,
});
export const getAdminInboxFail = (error) => ({
    type: GET_ADMIN_INBOX_FAIL,
    payload: error,
});

// ===================== ADMIN DECISION =====================
// payload attendu: { id, approved, comment }
export const adminDecisionRequest = (payload) => ({
    type: ADMIN_DECISION_REQUEST,
    payload,
});
export const adminDecisionSuccess = (data) => ({
    type: ADMIN_DECISION_SUCCESS,
    payload: data,
});
export const adminDecisionFail = (error) => ({
    type: ADMIN_DECISION_FAIL,
    payload: error,
});


// ===================== POSTPONE =====================
export const postponeLeaveRequestRequest = (payload) => ({
    type: POSTPONE_LEAVE_REQUEST_REQUEST,
    payload,
});
export const postponeLeaveRequestSuccess = (data) => ({
    type: POSTPONE_LEAVE_REQUEST_SUCCESS,
    payload: data,
});
export const postponeLeaveRequestFail = (error) => ({
    type: POSTPONE_LEAVE_REQUEST_FAIL,
    payload: error,
});

// ===================== EXPORT EXCEL =====================
export const EXPORT_LEAVE_REQUESTS_EXCEL_REQUEST = "EXPORT_LEAVE_REQUESTS_EXCEL_REQUEST";
export const EXPORT_LEAVE_REQUESTS_EXCEL_SUCCESS = "EXPORT_LEAVE_REQUESTS_EXCEL_SUCCESS";
export const EXPORT_LEAVE_REQUESTS_EXCEL_FAIL = "EXPORT_LEAVE_REQUESTS_EXCEL_FAIL";

export const exportLeaveRequestsExcelRequest = (scope) => ({
    type: EXPORT_LEAVE_REQUESTS_EXCEL_REQUEST,
    payload: scope,
});
export const exportLeaveRequestsExcelSuccess = () => ({
    type: EXPORT_LEAVE_REQUESTS_EXCEL_SUCCESS,
});
export const exportLeaveRequestsExcelFail = (error) => ({
    type: EXPORT_LEAVE_REQUESTS_EXCEL_FAIL,
    payload: error,
});

// ===================== GET ALL =====================
export const GET_ALL_LEAVE_REQUESTS_REQUEST = "GET_ALL_LEAVE_REQUESTS_REQUEST";
export const GET_ALL_LEAVE_REQUESTS_SUCCESS = "GET_ALL_LEAVE_REQUESTS_SUCCESS";
export const GET_ALL_LEAVE_REQUESTS_FAIL = "GET_ALL_LEAVE_REQUESTS_FAIL";

export const getAllLeaveRequestsRequest = () => ({
    type: GET_ALL_LEAVE_REQUESTS_REQUEST,
});
export const getAllLeaveRequestsSuccess = (data) => ({
    type: GET_ALL_LEAVE_REQUESTS_SUCCESS,
    payload: data,
});
export const getAllLeaveRequestsFail = (error) => ({
    type: GET_ALL_LEAVE_REQUESTS_FAIL,
    payload: error,
});
